import { Text } from '@mercator-gcp/grout';
import { Link } from 'react-router-dom';
import { CompanyItem } from 'types';
import { formatCompanyName } from 'utils/format';

type RenderCompaniesProps = {
  company: CompanyItem;
};

const CompanyContact = ({ company }: RenderCompaniesProps) => {
  if (company.uuid) {
    return (
      <Link className="textLink" to={`/companies/${company.uuid}`}>
        <Text.BodyBold>{formatCompanyName(company.name)}</Text.BodyBold>
      </Link>
    );
  }

  return <Text.BodyBold>{formatCompanyName(company.name)}</Text.BodyBold>;
};

export default CompanyContact;
